import React, { use, useEffect, useMemo, useState } from "react";
import {
  Grid,
  TextField,
  Button,
  MenuItem,
  Typography,
  Paper,
  Box,
  Card as MUICard,
  InputLabel,
  FormControl,
  Avatar,
  IconButton,
  FormHelperText,
  Snackbar,
  Alert,
  Button as MUIButton,
  Tooltip,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { PhotoCamera, AccountCircle, Cancel } from "@mui/icons-material";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import { bloodGroupList } from "components/BloodGroupList";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import MDAutocomplete from "components/MDAutocomplete";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDTextField from "components/MDTextField";
import PropTypes from "prop-types";
import { Visibility } from "@mui/icons-material";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import {
  ArrowLeft,
  BarChart3,
  Users,
  Calendar,
  Download,
  Edit,
  Trash2,
  Search,
  ArrowUp,
  ArrowDown,
  Plus,
} from "lucide-react";
import { MaterialReactTable } from "material-react-table";
import { IconTableExport } from "@tabler/icons-react";
import handleExport from "utils/exportData";
import { monthsList } from "components/BloodGroupList";
import Popper from "@mui/material/Popper";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { DateRange } from "react-date-range";
import { enUS } from "date-fns/locale";
import { format } from "date-fns";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { RadioGroup, RadioGroupItem } from "../../components/ui/radio-group";
import { Checkbox } from "../../components/ui/checkbox";
import { Star, Save, X } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";
import CloseIcon from "@mui/icons-material/Close";

export default function Report() {
  let { id } = useParams();
  const formIDAndTitle = id;

  id = id.split("--")[0];

  //   const [filters, setFilters] = useState({});

  const [message, setMessage] = useState({
    status: "",
    title: "",
    msg: "",
  });

  //   console.log("🚀 ~ Report ~ formID:", id);
  //   useEffect(() => {
  //     console.log("🚀 ~ Report ~ formID:", id);
  //   }, []);

  const [form, setForm] = useState();
  const [tableForm, setTableForm] = useState();
  const [openCalendar, setOpenCalendar] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedSubmission, setSelectedSubmission] = useState(null);
  const [loadingSubmission, setLoadingSubmission] = useState(false);
  const [formData, setFormData] = useState({});

  // state for selected date range
  const [selectedDateRange, setSelectedDateRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  useEffect(() => {
    const fetchFormById = async () => {
      //   if ((viewMode === "fill" || viewMode === "preview") && selectedForm) {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/forms/${id}`, {
          withCredentials: true,
        });
        // if (viewMode === "fill") {
        setForm(res.data.data);
        // } else if (viewMode === "preview") {
        //   setPreviewForm(res.data.data);
        // }
      } catch (err) {
        console.error("Error fetching form by ID:", err);
      }
    };
    // };

    fetchFormById();
  }, [id]);

  const [rowCount, setRowCount] = useState(0);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const [sorting, setSorting] = useState([]);
  const [columnFilters, setColumnFilters] = useState([]);
  const [originalSubmissions, setOriginalSubmissions] = useState([]);
  const [displayedSubmissions, setDisplayedSubmissions] = useState([]);
  const [rowSelection, setRowSelection] = useState({});

  const me = async () => {
    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/auth/me`,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    // console.log("🚀 ~ fetchUsers ~ response:", response);
    return response.data;
  };

  const {
    data: meData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["me"], // Unique key for the query
    queryFn: me, // The async function to run
    retry: false,
  });

  const fetchAllUsers = async () => {
    const response = await axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/user/role3`,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    return response.data.data;
  };

  const {
    data: usersData,
    error: usersError,
    isLoading: usersIsLoading,
  } = useQuery({
    queryKey: ["fetchAllUsers"],
    queryFn: fetchAllUsers,
    retry: false,
  });

  const fetchDistrict = async () => {
    const response = await axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/districts/all`,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    return response.data.data;
  };

  const {
    data: districtData,
    error: districtError,
    isLoading: districtIsLoading,
  } = useQuery({
    queryKey: ["fetchDistrict"],
    queryFn: fetchDistrict,
    retry: false,
  });

  const [filters, setFilters] = useState({});

  const clearFilters = () => {
    const cleared = {};
    form?.fields?.forEach((f) => {
      cleared[f.id] = "";
    });
    cleared["district_name"] = "";
    setFilters(cleared);

    // Reset pagination to page 1
    setPagination({ pageIndex: 0, pageSize: pagination.pageSize });

    // Fetch fresh data from backend (page 1, no filters)
    fetchFilteredData({}, 0, pagination.pageSize);
  };
  const [loading, setLoading] = useState(false);

  const columns = useMemo(() => {
    if (!tableForm?.fields) return [];

    const cols = [];

    // 1. District column (only for admin)
    if (meData?.user_id === 1) {
      cols.push({
        accessorKey: "district_namee",
        header: "District Name",
      });
    }

    cols.push(
      ...tableForm.fields.map((field) => ({
        accessorKey: field.id,
        header: field.label,
        // accessorFn: (row) => row.values?.[field.id] ?? "",
        accessorFn: (row) => {
          const value = row.values?.[field.id] ?? "";

          // handle array stored as JSON string
          if (field.type === "checkbox") {
            try {
              const parsed = JSON.parse(value);
              if (Array.isArray(parsed)) {
                return parsed.join(", "); // show: yes, no
              }
            } catch {
              // fallback if it's already plain string
              if (Array.isArray(value)) return value.join(", ");
            }
          }

          return value;
        },
        Cell: TooltipCell, // <-- use the component here
      }))
    );

    if (meData?.user_id === 1) {
      cols.push({
        accessorKey: "created_user",
        header: "Submitted User",
        Cell: TooltipCell, // <-- use it here too
      });
    }

    // 4. Submitted date
    cols.push({
      accessorKey: "created_at",
      header: "Submitted Date",
      Cell: ({ cell }) => dayjs(cell.getValue()).format("DD-MM-YYYY"),
    });
    // 5. View column (eye icon, sticky)
    cols.push({
      accessorKey: "view",
      header: "View",
      enableColumnFilter: false,
      enableSorting: false,
      size: 80,
      Cell: ({ row }) => (
        <Tooltip title="View submission">
          <span>
            <IconButton
              onClick={async () => {
                const { created_by, submission_id } = row.original;
                try {
                  setLoadingSubmission(true);
                  const response = await axios.get(
                    `${process.env.REACT_APP_API_URL}/submissions/${tableForm.id}`,
                    {
                      params: { created_by, submission_id },
                      withCredentials: true,
                    }
                  );
                  const result = response.data;
                  if (result.status === 200) {
                    const formDataResponse = result.data; // <-- unwrap the `data` object
                    const submission = Array.isArray(formDataResponse.submissions)
                      ? formDataResponse.submissions[0]
                      : formDataResponse.submissions;
                    setSelectedSubmission(response.data.data);
                    setOpenDialog(true);
                    setFormData(() => {
                      const initialData = {};
                      formDataResponse.fields.forEach((field) => {
                        // initialData[field.id] = submission?.[field.id] || "";
                        let fieldValue = submission?.[field.id] || "";
                        if (field.type === "checkbox") {
                          try {
                            fieldValue = fieldValue ? JSON.parse(fieldValue) : [];
                          } catch (err) {
                            fieldValue = [];
                          }
                        }
                        initialData[field.id] = fieldValue;
                      });
                      return initialData;
                    });
                  }
                } catch (err) {
                  console.error("Error fetching submission:", err);
                } finally {
                  setLoadingSubmission(false);
                }
              }}
              sx={{
                color: "#1976d2",
                transition: "background-color 0.3s, transform 0.3s",
                "&:hover": {
                  backgroundColor: "#1976d2",
                  color: "#fff",
                  transform: "scale(1.05)",
                },
                "&:active": {
                  transform: "scale(0.95)",
                },
              }}
            >
              <Visibility sx={{ width: 20, height: 20 }} />
            </IconButton>
          </span>
        </Tooltip>
      ),
      muiTableHeadCellProps: {
        sx: {
          position: "sticky",
          right: 0,
          zIndex: 2,
          backgroundColor: "#004030", // matches your table header style
          color: "#fff",
          fontWeight: "bold",
        },
      },
      muiTableBodyCellProps: {
        sx: {
          position: "sticky",
          right: 0,
          backgroundColor: "inherit", // 👈 important, matches alternating row color
        },
      },
    });

    // 5. Action buttons
    if (meData?.user_id !== 1) {
      cols.push({
        accessorKey: "edit",
        header: "Action",
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <Box display="flex" alignItems="center" gap={1}>
            <Tooltip title="Click to edit">
              <span>
                <IconButton
                  key={row.original.submission_id}
                  onClick={() => {
                    navigate(
                      `/mission-tracker/edit/${tableForm.id}/${row.original.created_by}/${row.original.submission_id}`
                    );
                  }}
                  disabled={loading}
                  sx={{
                    color: "#f48c06",
                    backgroundColor: "#fff",
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                    transition: "background-color 0.3s, transform 0.3s",
                    "&:hover": {
                      backgroundColor: "#f48c06",
                      color: "#fff",
                      transform: "scale(1.05)",
                    },
                    "&:active": {
                      transform: "scale(0.95)",
                    },
                  }}
                >
                  {loading ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    <Edit sx={{ width: 20, height: 20 }} />
                  )}
                </IconButton>
              </span>
            </Tooltip>
          </Box>
        ),
      });
    }

    return cols;
  }, [tableForm, meData?.user_id, loading]);

  const fetchFilteredData = async (
    appliedFilters,
    pageIndex = 0,
    pageSize = 10,
    sortValues = sorting,
    columnFilters = []
  ) => {
    try {
      setLoading(true);
      const formattedFilters = { ...appliedFilters };
      Object.keys(formattedFilters).forEach((key) => {
        const value = formattedFilters[key];
        if (!value) return;

        if (typeof value === "object" && value.$d) {
          formattedFilters[key] = dayjs(value).format("YYYY-MM-DD");
        } else if (value instanceof Date) {
          formattedFilters[key] = dayjs(value).format("YYYY-MM-DD");
        }
      });

      let url = "";
      if (meData?.user_id === 1) {
        url = `${process.env.REACT_APP_API_URL}/allforms/${form.id}`;
      } else {
        url = `${process.env.REACT_APP_API_URL}/submissions/${form.id}/${meData.user_id}`;
      }

      const res = await axios.get(url, {
        withCredentials: true,
        params: {
          ...formattedFilters,
          page: pageIndex + 1,
          limit: pageSize,
          sorting: JSON.stringify(sorting),
          columnFilters: JSON.stringify(columnFilters),
        }, // ✅ send page & limit
      });

      if (res?.data?.data?.submissions) {
        setTableForm(res.data.data);
        setOriginalSubmissions(res.data.data.submissions);
        setDisplayedSubmissions(res.data.data.submissions);
        setRowCount(res.data.data.totalCount); // ✅ use totalCount from backend
      }
    } catch (err) {
      console.error("Error fetching filtered data:", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (form) {
      fetchFilteredData(filters, pagination.pageIndex, pagination.pageSize, sorting, columnFilters);
    }
  }, [form, pagination, sorting, columnFilters, meData?.user_id]);

  const handleExportData = async () => {
    try {
      let formattedData = [];

      if (rowSelection && Object.keys(rowSelection).length > 0) {
        formattedData = form.submissions.filter((item, index) => rowSelection[index]);
      } else {
        // fetch ALL data directly for export
        const url =
          meData?.user_id === 1
            ? `${process.env.REACT_APP_API_URL}/allforms/${form.id}`
            : `${process.env.REACT_APP_API_URL}/submissions/${form.id}/${meData.user_id}`;

        const res = await axios.get(url, {
          withCredentials: true,
          params: { ...filters, page: 1, limit: 100000 }, // huge limit to get everything
        });

        formattedData = res.data?.data?.submissions || [];
      }

      if (formattedData.length === 0) {
        setMessage({
          status: "error",
          title: "Error",
          msg: "No data found to export.",
        });
        return;
      }

      const exportPayload = {
        ...tableForm,
        submissions: formattedData,
      };

      await handleExport(exportPayload, "Form_Submissions_List_Data");

      setMessage({
        status: "success",
        title: "Success",
        msg: "Excel downloaded successfully!",
      });
    } catch (error) {
      console.error("Export error:", error);
      setMessage({
        status: "error",
        title: "Error",
        msg: "Something went wrong during export.",
      });
    }
  };

  const paginatedData = useMemo(() => {
    let data = [...(displayedSubmissions || [])];

    return data; // ✅ return fully filtered & sorted data, no frontend pagination
  }, [displayedSubmissions]);
  const navigate = useNavigate();

  const [rotate, setRotate] = React.useState(0);
  const handleMouseEnter = () => {
    setRotate(360);
  };

  const handleMouseLeave = () => {
    setRotate(180);
  };
  return (
    <DashboardLayout>
      <Snackbar
        open={Boolean(message.status)}
        autoHideDuration={3000}
        onClose={() => setMessage({ status: "", title: "", msg: "" })}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setMessage({ status: "", title: "", msg: "" })}
          severity={message.status}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message.msg}
        </Alert>
      </Snackbar>
      {/* <div>Rendering dynamic form: {id}</div> */}
      <div className="flex-between" style={{ marginBottom: "1.5rem" }}>
        <h2 className="section-title">
          {formIDAndTitle?.includes("--") ? formIDAndTitle.split("--")[1].replaceAll("-", " ") : ""}
        </h2>
        {meData?.user_id !== 1 && (
          <Button
            className="btn btn-primary"
            onClick={() => navigate("/mission-tracker/add/" + formIDAndTitle)}
            style={{ backgroundColor: "#004030", borderColor: "#004030", color: "white" }}
          >
            <Plus className="icon" />
            Add
          </Button>
        )}
      </div>
      <div className="form-report-grid">
        <Card
          className="form-report-analytic-card"
          style={{ backgroundColor: "#35bbcab3", color: "white" }}
        >
          <CardHeader className="form-report-header-row">
            <CardTitle className="form-report-analytic-title">Total Submissions</CardTitle>
            <Users className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="form-report-analytic-value">{tableForm?.stats?.total || 0}</div>
            <p className="form-report-analytic-sub">All time responses</p>
          </CardContent>
        </Card>

        <Card
          className="form-report-analytic-card"
          style={{ backgroundColor: "#5fa55ab3", color: "white" }}
        >
          <CardHeader className="form-report-header-row">
            <CardTitle className="form-report-analytic-title">Today</CardTitle>
            <Calendar className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="form-report-analytic-value">{tableForm?.stats?.today || 0}</div>
            <p className="form-report-analytic-sub">Submissions today</p>
          </CardContent>
        </Card>

        <Card
          className="form-report-analytic-card"
          style={{ backgroundColor: "#ec3432b3", color: "white" }}
        >
          <CardHeader className="form-report-header-row">
            <CardTitle className="form-report-analytic-title">This Week</CardTitle>
            <BarChart3 className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="form-report-analytic-value">{tableForm?.stats?.thisWeek || 0}</div>
            <p className="form-report-analytic-sub">Last 7 days</p>
          </CardContent>
        </Card>

        <Card
          className="form-report-analytic-card"
          style={{ backgroundColor: "#ff8a25b3", color: "white" }}
        >
          <CardHeader className="form-report-header-row">
            <CardTitle className="form-report-analytic-title">This Month</CardTitle>
            <BarChart3 className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="form-report-analytic-value">{tableForm?.stats?.thisMonth || 0}</div>
            <p className="form-report-analytic-sub">Last 30 days</p>
          </CardContent>
        </Card>
      </div>
      <MDBox mt={3} />
      <MUICard
        id="delete-account"
        sx={{
          mb: 3,
          // border: "2px solid #2bc29c", // green border
          borderRadius: "10px", // optional, for rounded corners
        }}
      >
        <MDBox pt={2} px={2} pb={3}>
          <Grid container spacing={1} display={"flex"} alignItems={"center"}>
            <Grid item size={{ xs: 12, sm: 6, md: 6 }}>
              <MDTypography variant="h5" fontWeight="medium">
                Filters
              </MDTypography>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6 }} display="flex" justifyContent="flex-end">
              <FormControlLabel
                control={
                  <Switch
                    checked={showAdvanced}
                    onChange={() => setShowAdvanced((prev) => !prev)}
                    color="primary"
                  />
                }
                label={showAdvanced ? "Hide Advanced Filters" : "Advanced Filters"}
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontSize: "0.9rem",
                    fontWeight: 500,
                    color: showAdvanced ? "#1976d2" : "#555",
                  },
                }}
              />
            </Grid>
          </Grid>
        </MDBox>
        <MDBox px={2} pt={0.5}>
          <Grid container spacing={3}>
            {/* District (always first) */}
            {meData?.user_id === 1 && (
              <>
                <Grid item size={{ xs: 12, md: 6 }}>
                  <MDAutocomplete
                    label="District"
                    name="district_name"
                    value={filters.district_name || ""}
                    options={districtData}
                    onChange={(newValue) => setFilters({ ...filters, district_name: newValue })}
                    isFilter
                  />
                </Grid>
                <Grid item size={{ xs: 12, md: 6 }}>
                  <MDAutocomplete
                    label="Users"
                    name="user"
                    value={filters.user || ""}
                    options={usersData}
                    onChange={(newValue) => setFilters({ ...filters, user: newValue })}
                    isFilter
                  />
                </Grid>
              </>
            )}

            <Grid item size={{ xs: 12, md: 6 }}>
              <MDAutocomplete
                label="Month"
                name="field_month"
                value={filters.field_months || ""}
                options={monthsList}
                onChange={(newValue) => setFilters({ ...filters, field_months: newValue })}
                isFilter
              />
            </Grid>

            <Grid item size={{ xs: 12, md: 6 }}>
              <Box>
                <Typography sx={{ fontSize: "0.887rem", fontWeight: 400, mb: 0.3 }}>
                  Date Range
                </Typography>
                <TextField
                  fullWidth
                  value={
                    filters.start_date && filters.end_date
                      ? `${filters.start_date} to ${filters.end_date}`
                      : ""
                  }
                  placeholder="Select Date Range"
                  onClick={(e) => {
                    setAnchorEl(e.currentTarget);
                    setOpenCalendar(true);
                  }}
                  InputProps={{
                    readOnly: true,
                    sx: {
                      cursor: "pointer",
                      backgroundColor: "#fff",
                      height: "51px",
                    },
                  }}
                />
                <Popper
                  open={openCalendar}
                  anchorEl={anchorEl}
                  placement="bottom-start"
                  style={{ zIndex: 1300 }}
                >
                  <ClickAwayListener onClickAway={() => setOpenCalendar(false)}>
                    <Box
                      sx={{
                        mt: 1,
                        bgcolor: "white",
                        boxShadow: 3,
                        borderRadius: 2,
                        p: 2,
                        zIndex: 1301,
                      }}
                    >
                      <DateRange
                        editableDateInputs={true}
                        onChange={(item) => {
                          setSelectedDateRange([item.selection]);
                          const start = item.selection.startDate;
                          const end = item.selection.endDate;
                          setFilters({
                            ...filters,
                            start_date: start ? format(start, "dd-MM-yyyy") : "",
                            end_date: end ? format(end, "dd-MM-yyyy") : "",
                          });
                          if (start && end && start.getTime() !== end.getTime()) {
                            setOpenCalendar(false);
                          }
                        }}
                        moveRangeOnFirstSelection={false}
                        ranges={selectedDateRange}
                        rangeColors={["#1976d2"]}
                        maxDate={new Date()}
                        locale={enUS}
                      />
                    </Box>
                  </ClickAwayListener>
                </Popper>
              </Box>
            </Grid>

            {!tableForm || loading ? (
              // Loader instead of form fields
              <Box display="flex" justifyContent="center" alignItems="center" minHeight="25vh">
                <CircularProgress size={40} thickness={4} />
              </Box>
            ) : (
              <Grid container spacing={2}>
                {showAdvanced &&
                  form.fields
                    .filter((field) => field.id !== "field_months") // hide months field
                    .map((field) => (
                      <Grid key={field.id} item size={{ xs: 12, md: 4 }}>
                        {field.type === "text" ||
                        field.type === "email" ||
                        field.type === "phone" ||
                        field.type === "number" ? (
                          <MDTextField
                            name={field.id}
                            value={filters[field.id] || ""}
                            onChange={(e) => setFilters({ ...filters, [field.id]: e })}
                            placeholder={field.placeholder}
                            displayName={field.label}
                            inputType={field.type === "phone" ? "numeric" : "onlyString"}
                          />
                        ) : field.type === "date" ? (
                          <>
                            <MDTypography style={{ fontSize: "16px" }} color="dark">
                              {field.label}
                            </MDTypography>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                value={filters[field.id] || null}
                                format="DD/MM/YYYY"
                                onChange={(value) => setFilters({ ...filters, [field.id]: value })}
                                slotProps={{
                                  textField: {
                                    fullWidth: true,
                                    size: "small",
                                    InputProps: {
                                      readOnly: true,
                                      sx: {
                                        fontSize: "14px",
                                        height: "45px",
                                      },
                                    },
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          </>
                        ) : field.type === "select" ||
                          field.type === "radio" ||
                          field.type === "checkbox" ||
                          field.type === "rating" ? (
                          <MDAutocomplete
                            label={field.label}
                            name={field.id}
                            value={filters[field.id] || ""}
                            options={
                              field.type === "rating"
                                ? [1, 2, 3, 4, 5].map((num) => ({
                                    title: num.toString(),
                                    value: num,
                                  }))
                                : field.options?.map((opt) => ({ title: opt, value: opt })) || []
                            }
                            onChange={(newValue) =>
                              setFilters({ ...filters, [field.id]: newValue })
                            }
                            isFilter
                          />
                        ) : null}
                      </Grid>
                    ))}
              </Grid>
            )}
          </Grid>
        </MDBox>

        {/* Action Buttons */}
        <MDBox p={2}>
          <Grid container spacing={2} justifyContent="center">
            <Grid item xs={12} md={2} textAlign="center">
              <MDButton
                onClick={() => fetchFilteredData(filters)}
                sx={{
                  color: "white !important",
                  backgroundColor: "#1976d2",
                  "&:hover": { backgroundColor: "#155fa0" },
                  minWidth: "120px",
                }}
              >
                Search
              </MDButton>
            </Grid>
            <Grid item xs={12} md={2} textAlign="center">
              <MDButton
                variant="outlined"
                onClick={clearFilters}
                sx={{
                  color: "#b71c1c !important",
                  borderColor: "#b71c1c",
                  "&:hover": {
                    backgroundColor: "#fbe9e7",
                    borderColor: "#b71c1c",
                  },
                  minWidth: "120px",
                }}
              >
                Cancel
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>
      </MUICard>

      <Box>
        <Grid container spacing={5}>
          <Grid item size={{ xs: 12, md: 12 }} className="listTable">
            <Box sx={{ width: "100%", overflowX: "auto" }}>
              <Paper
                elevation={2}
                sx={{
                  width: "100%",
                  overflowX: "auto",
                  backgroundColor: "#fff",
                  boxShadow: "none",
                  p: 2,
                }}
              >
                <MaterialReactTable
                  columns={columns}
                  data={paginatedData}
                  enableGlobalFilter={false}
                  enableFullScreenToggle={false}
                  enableColumnFilters={false}
                  enableDensityToggle={false}
                  initialState={{ showColumnFilters: false }}
                  layoutMode="grid"
                  enableRowNumbers
                  enableStickyHeader
                  manualFiltering
                  manualPagination
                  manualSorting
                  onPaginationChange={setPagination}
                  onSortingChange={setSorting}
                  onColumnFiltersChange={setColumnFilters}
                  rowCount={rowCount}
                  state={{ pagination, sorting, columnFilters, isLoading: loading }}
                  muiTableHeadProps={{
                    sx: {
                      padding: "0px", // won't apply directly to <thead>, but useful for general structure
                      backgroundColor: "#011F3A", // background on <thead> element itself
                    },
                  }}
                  enableColumnActions={false}
                  muiTableHeadCellProps={{
                    sx: {
                      backgroundColor: "#004030",
                      color: "#fff",
                      // fontSize: '16px',
                      fontWeight: "bold",
                      position: "sticky", // Make header sticky
                      top: 0, // Stick it at the top
                      zIndex: 1, // Ensure it stays
                      "& .MuiTableSortLabel-root": {
                        "& .MuiTableSortLabel-icon": {
                          color: "#fff !important",
                        },
                      },
                      "& .MuiInputBase-input": {
                        color: "#fff !important",
                        fontSize: "12px",
                        "::placeholder": {
                          color: "#e0e0e0", // Default (blurred) placeholder color
                          opacity: 1,
                        },
                      },
                      "& .MuiInputBase-root.Mui-focused .MuiInputBase-input::placeholder": {
                        color: "#ffffff", // Focused placeholder color
                      },
                      "& .MuiIconButton-root": {
                        color: "#fff",
                      },
                      "& .MuiInput-underline:before": {
                        borderBottomColor: "#e0e0e0",
                      },
                      "& .MuiInput-underline:after": {
                        borderBottomColor: "#fff",
                      },
                      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                        borderBottomColor: "#fff",
                      },

                      "& .MuiCheckbox-root": {
                        color: "#fff",
                      },
                    },
                  }}
                  muiTableBodyCellProps={{
                    sx: {
                      padding: "8px", // reduce from default 16px
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    },
                  }}
                  muiTableBodyRowProps={({ row }) => ({
                    sx: {
                      backgroundColor: row.index % 2 === 0 ? "#fafafa" : "#f0f0f0", // soft alternating colors
                    },
                  })}
                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "1rem",
                        p: "0.5rem",
                        flexWrap: "wrap",
                      }}
                    >
                      <Tooltip title={"Export data to excel sheet"} arrow>
                        <MUIButton
                          onClick={handleExportData}
                          sx={{
                            background:
                              "linear-gradient(90deg, rgba(2, 183, 255, 0.65) 30%,rgb(110, 199, 235) 100%)",
                            color: "#f4f4f4",
                            borderRadius: "8px",
                            padding: "10px 20px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                            transition: "background 0.3s, transform 0.3s",
                            "&:hover": {
                              background:
                                "linear-gradient(90deg, rgba(55, 198, 254, 0.97) 30%,rgb(39, 169, 220) 100%))",
                              transform: "scale(1.05)",
                            },
                            "&:active": {
                              transform: "scale(0.95)",
                            },
                          }}
                          startIcon={<IconTableExport />}
                        >
                          {"Export To Excel"}
                        </MUIButton>
                      </Tooltip>
                    </Box>
                  )}
                  muiTopToolbarProps={{
                    sx: {
                      backgroundColor: "#fff",
                      boxShadow: "none",
                    },
                  }}
                />
              </Paper>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth="md"
        fullWidth
        sx={{
          "& .MuiPaper-root": {
            borderRadius: 2,
            boxShadow: 6,
            position: "relative",
            overflow: "visible",
          },
        }}
      >
        <IconButton
          onClick={() => setOpenDialog(false)}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          sx={{
            position: "absolute",
            top: -18,
            right: -16,
            backgroundColor: "#fff",
            color: "#ff0a54",
            boxShadow: 1,
            zIndex: 1500,
            p: 1.5,
            "&:hover": {
              backgroundColor: "#ff0a54",
              color: "#fff",
            },
            transition: "transform 0.5s ease",
            transform: `rotate(${rotate}deg)`,
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle
          sx={{
            background: "linear-gradient(45deg, #f48c06, #191919)",
            color: "white !important",
            fontWeight: "bold",
            fontSize: "18px",
            textAlign: "center",
            position: "relative",
            zIndex: 1400,
            py: 2,
          }}
        >
          Submission Details
        </DialogTitle>
        <DialogContent dividers>
          {loadingSubmission ? (
            <CircularProgress />
          ) : selectedSubmission ? (
            <Card className="submission-renderer-card">
              <CardHeader className="submission-renderer-header">
                <CardTitle className="submission-renderer-title">
                  {selectedSubmission.submissions?.[0]?.created_user}-{" "}
                  {selectedSubmission.submissions?.[0]?.district_name}
                </CardTitle>
                <CardDescription className="submission-renderer-desc">
                  Viewing submitted data for &quot;{form?.title}&quot;
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  {form?.fields?.map((field) => {
                    const value = formData[field.id] ?? "";

                    const renderPreviewField = () => {
                      switch (field.type) {
                        case "textarea":
                        case "text":
                        case "email":
                        case "phone":
                        case "number":
                          return (
                            <Input
                              value={value}
                              readOnly
                              disabled
                              className="submission-input bg-gray-100 cursor-not-allowed"
                            />
                          );

                        case "select":
                          return (
                            <Select value={value} disabled>
                              <SelectTrigger className="submission-select">
                                <SelectValue
                                  placeholder={field.placeholder || "Select an option"}
                                />
                              </SelectTrigger>
                              <SelectContent className="submission-select-dropdown">
                                {field.options?.map((option, idx) => (
                                  <SelectItem key={idx} value={option}>
                                    {option}
                                  </SelectItem>
                                ))}
                              </SelectContent>
                            </Select>
                          );

                        case "radio":
                          return (
                            <RadioGroup value={value} disabled>
                              {field.options?.map((option, idx) => (
                                <div
                                  key={idx}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                    marginBottom: "6px",
                                    minHeight: "28px",
                                  }}
                                >
                                  <RadioGroupItem
                                    value={option}
                                    checked={value === option}
                                    disabled
                                  />
                                  <Label
                                    htmlFor={`${field.id}-${idx}`}
                                    className="submission-radio-item"
                                  >
                                    {option}
                                  </Label>
                                </div>
                              ))}
                            </RadioGroup>
                          );

                        case "checkbox":
                          const checkboxValues = Array.isArray(value) ? value : [];
                          return (
                            <div className="submission-radio-group">
                              {field.options?.map((option, idx) => (
                                <div
                                  key={idx}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                    marginBottom: "6px",
                                    minHeight: "28px",
                                  }}
                                >
                                  <Checkbox
                                    checked={checkboxValues.includes(option)}
                                    disabled
                                    id={`${field.id}-${idx}`}
                                  />
                                  <Label
                                    htmlFor={`${field.id}-${idx}`}
                                    className="submission-radio-item"
                                  >
                                    {option}
                                  </Label>
                                </div>
                              ))}
                            </div>
                          );

                        case "rating":
                          return (
                            <div className="submission-rating">
                              {[1, 2, 3, 4, 5].map((star) => (
                                <Star
                                  key={star}
                                  className={`submission-rating-star ${
                                    star <= (value || 0) ? "active" : ""
                                  }`}
                                  style={{
                                    pointerEvents: "none",
                                    color: star <= (value || 0) ? "#3b82f6" : "#d1d5db",
                                  }}
                                />
                              ))}
                            </div>
                          );

                        default:
                          return (
                            <Input
                              value={value}
                              readOnly
                              disabled
                              className="submission-input bg-gray-100 cursor-not-allowed"
                            />
                          );
                      }
                    };

                    return (
                      <div key={field.id} className="submission-field">
                        <Label htmlFor={field.id} className="submission-label">
                          {field.label}
                        </Label>
                        {renderPreviewField()}
                      </div>
                    );
                  })}
                </div>
              </CardContent>
            </Card>
          ) : (
            <p>No submission details found</p>
          )}
        </DialogContent>
      </Dialog>
    </DashboardLayout>
  );
}

const TooltipCell = ({ cell }) => {
  const value = cell?.getValue?.() ?? "";

  // show only first 20 chars in the table cell
  const displayValue = value.length > 20 ? value.substring(0, 20) + "..." : value;

  return (
    <Tooltip title={value}>
      <span>{displayValue}</span>
    </Tooltip>
  );
};

TooltipCell.propTypes = {
  cell: PropTypes.shape({
    getValue: PropTypes.func, // optional func, validated
  }).isRequired,
};
